import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import "./Navbar.css";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const NavScrollExample = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  return (
    <>
      <section id="nav_top">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <h5>Welcome To Our Organsio Store.</h5>
            </div>
          </div>
        </div>
      </section>
      <Navbar expand="lg">
        <Container>
          <Navbar.Brand href="#"><img src="imeges/Organic.png" alt="" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="mx-auto my-2 my-lg-0" style={{ maxHeight: '100px', columnGap: '40px' }} navbarScroll>
              <Nav.Link>
                <Link className="red-link" to="/">Home</Link>
              </Nav.Link>
              <Nav.Link>
                <Link className="red-link" to="/Desktop9">accessoreis</Link>
              </Nav.Link>
              <Nav.Link>
                <Link className="red-link" to="/Desktop1">ctegory</Link>
              </Nav.Link>
              <Nav.Link><Link className="red-link" to="/Desktop2">shop</Link></Nav.Link>
              <Nav.Link>
                <Link className="red-link" to="/Desktop3">about us</Link>
              </Nav.Link>
              <Nav.Link>
                <Link className="red-link" to="/Desktop5">faqs</Link>
              </Nav.Link>
            </Nav>
            <div className="navber_icon">
              <Link className="fa-solid fa-cart-shopping" to="/Desktop6"></Link>
              <i className={`fa-solid fa-magnifying-glass search_icon ${isSearchOpen ? 'open' : ''}`} onClick={toggleSearch}></i>
              {isSearchOpen && (
                <Form className="search-form">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    className="me-2"
                    aria-label="Search"
                  />
                </Form>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default NavScrollExample;
